<template>
  <div class="sm:flex sm:mb-6 sm:mt-4">

    <div @click="handle_department_link" class="sm:w-max mb-2 sm:mb-0 flex cursor-pointer sm:mr-3 h-28 xbg-yellow-300 bg-white">
      <img :src="`${department.logo}?${random_value}`" class="logo object-cover bg-cover bg-center h-28">
    </div>

    <div v-if="$route.params.id" class="sm:flex sm:w-full w-screen sm:h-28">
      <div v-for="topic in department_topics"
        :key="topic.id"
        class="flex flex-col w-36 sm:relative cursor-pointer h-auto sm:h-28 mr-2 mb-1 sm:mb-4 items-end font-normal"
        :class="{ 'bg-ams-blue text-white': topic.id === current_topic_id,
                  'bg-gray-300': topic.id !== current_topic_id,
                  'sm:w-1/2': department_topics.length == 2,
                  'sm:w-1/3': department_topics.length == 3,
                  'sm:w-1/4': department_topics.length == 4 }"
        @click="handle_topic_link(topic.id)"
      >
        <span class="w-full sm:absolute break-words mt-2 sm:bottom-0 pr-2 pb-1 text-right text-sm md:text-lg uppercase">
          {{ topic.title }}
        </span>
      </div>
    </div>
    <div v-else class="hidden sm:block w-3/4 h-28 col-span-2 bg-cover bg-center"
      :style="{ 'background-image': 'url(' + department.image + ')' }">
      <img v-if="false" :src="department.image" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  methods: {
    ...mapMutations(['set_current_topic_id', 'set_current_department_id']),
    handle_department_link() {
      this.set_current_department_id( this.current_department_id )
      this.$router.push("/")
    },
    handle_topic_link( id ) {
      this.set_current_topic_id( id )
      this.$router.push(`/topic/${id}`)
    }
  },
  computed: {
    ...mapState(['department','current_department_id','current_topic_id','current_subject_id']),
    ...mapGetters(['department_topics']),
    random_value: () => Math.random()
  }
}
</script>

<style scoped>
.logo {
  min-width: 180px;
}
</style>
